import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c8319574")

_pushScopeId("data-v-c8319574")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "nav flex" }
const _hoisted_3 = { class: "flex alignC top-button-group" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "点击设置", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_Worksheet = _resolveComponent("Worksheet")
  const _component_WorksheetRequired = _resolveComponent("WorksheetRequired")
  const _component_Percentage = _resolveComponent("Percentage")
  const _component_Remind = _resolveComponent("Remind")
  const _component_Other = _resolveComponent("Other")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
        return (_openBlock(), _createBlock("p", {
          class: ["mar-r-20", { 'nav-range c-red': index == _ctx.navIndex }],
          key: index,
          onClick: ($event: any) => (_ctx.navIndex = index)
        }, _toDisplayString(item), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setChange(_ctx.navIndex)))
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createVNode(_component_Worksheet, { ref: "worksheet" }, null, 512), [
      [_vShow, _ctx.navIndex == 0]
    ]),
    _withDirectives(_createVNode(_component_WorksheetRequired, { ref: "worksheetRequired" }, null, 512), [
      [_vShow, _ctx.navIndex == 1]
    ]),
    _withDirectives(_createVNode(_component_Percentage, { ref: "percentage" }, null, 512), [
      [_vShow, _ctx.navIndex == 2]
    ]),
    _withDirectives(_createVNode(_component_Remind, { ref: "remind" }, null, 512), [
      [_vShow, _ctx.navIndex == 3]
    ]),
    _withDirectives(_createVNode(_component_Other, { ref: "other" }, null, 512), [
      [_vShow, _ctx.navIndex == 4]
    ])
  ]))
})